module.exports = __webpack_public_path__ + "img/浙江树人大学.5f51806e.png";